// Query key factory for React Query
export const qk = {
  me: () => ["me"] as const,
};
